import { Radio, RadioGroup, FormControlLabel } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = ({ hideRadioButtons, hideScrollButton, ContentHideAbout, ContentHideHome, onRadioChange }) => {
  const [selectedValue, setSelectedValue] = useState('2');
  const navigate = useNavigate();

  const handleChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);

    // Call the parent function to change the background image
    if (onRadioChange) {
      onRadioChange(newValue);
    }
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className='container'>
      <div className='footer-content-div'>
        {!ContentHideAbout && (
          <div className='content-div'>
            <p onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
              navigate("/about", { replace: true });
              setTimeout(() => {
                document.getElementById("total-floors-section").scrollIntoView({ behavior: 'smooth' });
              }, 500);
            }}>factsheet</p>
            <p onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); navigate("/availability"); }}>
              Availability
            </p>
            <p onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); navigate("/gallery"); }}>
              Gallery
            </p>
            <p onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); navigate("/videos"); }}>videos</p>
            <p onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); navigate("/location"); }}>
              live location
            </p>
          </div>
        )}
        {!ContentHideHome && (
          <div className='content-div'>
            <p onClick={() => scrollToSection('features-section')}>Features</p>
            <p onClick={() => scrollToSection('total-floors-section')}>Orientation</p>
            <p onClick={() => scrollToSection('specifications-section')}>Specifications</p>
          </div>
        )}
        <div className='button-logos-main-div'>
          <div className='buttons-div'>
            <div className='footer-button'>
              <button onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); navigate("/floor-selection"); }}>
                Select An Apartment
              </button>
            </div>
            <div className='virtualtour-logo-div-main'>
              <div className='footer-button'>
                <button onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); navigate("/virtual-tour"); }}>
                  Virtual Tour
                </button>
              </div>
              <div className='logo-button'>
                <a href="tel:+97142446348" className='button-mobile'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 20" fill="none">
                    <path d="M4.07538 13.2947C6.04803 15.6527 8.42267 17.5093 11.133 18.823C12.1649 19.3121 13.5449 19.8923 15.0824 19.9917C15.1777 19.9959 15.2689 20 15.3642 20C16.3961 20 17.225 19.6436 17.9005 18.9101C17.9046 18.9059 17.9129 18.8976 17.9171 18.8893C18.1574 18.5993 18.431 18.3382 18.7169 18.0605C18.9117 17.874 19.1106 17.6792 19.3012 17.4803C20.184 16.5603 20.184 15.3916 19.293 14.5006L16.8023 12.0099C16.3796 11.5707 15.874 11.3386 15.3435 11.3386C14.8131 11.3386 14.3033 11.5707 13.8682 12.0058L12.3845 13.4894C12.2478 13.4107 12.1069 13.3402 11.9743 13.2739C11.8085 13.191 11.6552 13.1123 11.5184 13.0253C10.1674 12.1674 8.9407 11.0485 7.76788 9.61044C7.17526 8.86034 6.77742 8.23042 6.49975 7.58807C6.88931 7.23581 7.254 6.86697 7.60626 6.50642C7.73059 6.37795 7.85906 6.24948 7.98753 6.12101C8.4351 5.67344 8.67547 5.15541 8.67547 4.62909C8.67547 4.10278 8.43925 3.58475 7.98753 3.13717L6.75255 1.9022C6.6075 1.75715 6.47074 1.61625 6.32984 1.4712C6.05632 1.18939 5.77037 0.899296 5.48856 0.63821C5.06171 0.219644 4.56026 0 4.0298 0C3.50348 0 2.99789 0.219644 2.55446 0.642354L1.00452 2.19229C0.440905 2.75591 0.1218 3.4397 0.0554928 4.23125C-0.0232474 5.22172 0.159098 6.27435 0.631539 7.54662C1.35678 9.51513 2.45085 11.3427 4.07538 13.2947ZM1.06668 4.31828C1.11641 3.76709 1.32777 3.30709 1.72561 2.90924L3.26726 1.36759C3.50763 1.13552 3.77286 1.01533 4.0298 1.01533C4.2826 1.01533 4.53954 1.13552 4.77576 1.37588C5.05342 1.63282 5.31451 1.9022 5.59631 2.18815C5.73722 2.3332 5.88226 2.47824 6.02731 2.62743L7.26229 3.86241C7.51923 4.11935 7.65185 4.38044 7.65185 4.63738C7.65185 4.89432 7.51923 5.15541 7.26229 5.41235C7.13382 5.54082 7.00535 5.67344 6.87688 5.80191C6.49146 6.19146 6.13092 6.5603 5.73307 6.91256C5.72478 6.92085 5.72064 6.92499 5.71235 6.93328C5.36838 7.27725 5.42226 7.60464 5.50514 7.85329C5.50928 7.86573 5.51343 7.87402 5.51757 7.88645C5.83668 8.65313 6.28011 9.38251 6.97219 10.2528C8.21546 11.7862 9.52503 12.9755 10.9672 13.8914C11.1454 14.0075 11.3361 14.0986 11.5143 14.1898C11.68 14.2727 11.8334 14.3514 11.9701 14.4385C11.9867 14.4467 11.9991 14.455 12.0157 14.4633C12.1525 14.5338 12.2851 14.5669 12.4177 14.5669C12.7492 14.5669 12.9647 14.3556 13.0352 14.2851L14.5851 12.7352C14.8255 12.4948 15.0866 12.3663 15.3435 12.3663C15.6585 12.3663 15.9154 12.5611 16.077 12.7352L18.576 15.23C19.0733 15.7273 19.0692 16.2661 18.5636 16.7924C18.3895 16.9789 18.2072 17.1571 18.0124 17.3436C17.7223 17.6254 17.4198 17.9155 17.1462 18.2429C16.6697 18.7567 16.1019 18.9971 15.3684 18.9971C15.2979 18.9971 15.2233 18.993 15.1529 18.9888C13.7936 18.9018 12.5296 18.3713 11.5806 17.9196C9.00286 16.6722 6.74012 14.9026 4.86279 12.6564C3.31699 10.7957 2.27679 9.06341 1.58885 7.2068C1.162 6.06714 1.00037 5.15126 1.06668 4.31828Z" fill="white" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          {!hideRadioButtons && (
            <div className='radio-button'>
              <RadioGroup value={selectedValue} onChange={handleChange} row>
                <FormControlLabel value="1" control={<Radio sx={{ color: '#C8AA8E', '&.Mui-checked': { color: '#C8AA8E' } }} />} />
                <FormControlLabel value="2" control={<Radio sx={{ color: '#C8AA8E', '&.Mui-checked': { color: '#C8AA8E' } }} />} />
                <FormControlLabel value="3" control={<Radio sx={{ color: '#C8AA8E', '&.Mui-checked': { color: '#C8AA8E' } }} />} />
              </RadioGroup>
            </div>
          )}
          {!hideScrollButton && (
            <div className='scroller-about-div'>
              <img src={"https://greendirectorydata.s3.us-east-2.amazonaws.com/Frame%20300.gif"} alt='ScrollLogo' />
            </div>
          )}
        </div>
      </div>
    </div >
  );
};

export default Footer;
